import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 text-center">
      <p className="font-heading text-7xl md:text-9xl text-primary-300 mb-4">404</p>
      <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">页面未找到</h1>
      <p className="text-sm text-foreground-500 max-w-md mb-8 leading-relaxed">
        您访问的页面不存在或已被移除，请检查链接是否正确
      </p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
      >
        <i className="ri-home-4-line"></i> 返回首页
      </Link>
    </div>
  );
}